import React from 'react';
import { FiX, FiCheckCircle, FiFileText } from 'react-icons/fi';
import * as S from '../../styles/inlineStyles';

const SubmissionReviewModal = ({ isOpen, onClose, data, apiBaseUrl }) => {
    if (!isOpen || !data) return null;

    const { submission, questions, paper } = data;
    const answers = JSON.parse(submission?.answers || '[]');

    return (
        <div style={S.confirmOverlay} onClick={onClose}>
            <div style={{ 
                ...S.confirmModal, 
                maxWidth: 800, 
                width: '95%', 
                maxHeight: '90vh', 
                overflowY: 'auto', 
                padding: 0,
                textAlign: 'left',
                zIndex: 1001
            }} onClick={e => e.stopPropagation()}>
                {/* Modal Header */}
                <div style={{ 
                    padding: '20px 24px', 
                    borderBottom: `1px solid ${S.colors.border}`, 
                    position: 'sticky', 
                    top: 0, 
                    background: '#fff', 
                    zIndex: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: S.colors.textPrimary }}>
                            {paper?.subject_name} ({paper?.subject_code})
                        </h2>
                        <p style={{ margin: '4px 0 0 0', fontSize: 13, color: S.colors.textSecondary }}>
                            Submission Review · {submission?.total_score} / {paper?.total_marks} Marks
                        </p>
                    </div>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: S.colors.textSecondary }}>
                        <FiX size={24} />
                    </button>
                </div>

                {/* Modal Content */}
                <div style={{ padding: '24px' }}>
                    {/* Summary Stats */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 16, marginBottom: 30 }}>
                        <div style={{ padding: 16, background: '#f8fafc', borderRadius: 12, border: '1px solid #e2e8f0' }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: S.colors.textSecondary, textTransform: 'uppercase', marginBottom: 4 }}>Submission Time</div>
                            <div style={{ fontSize: 14, fontWeight: 800, color: S.colors.textPrimary }}>{submission?.submitted_at ? new Date(submission.submitted_at).toLocaleString() : 'N/A'}</div>
                        </div>
                        <div style={{ padding: 16, background: '#f8fafc', borderRadius: 12, border: '1px solid #e2e8f0' }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: S.colors.textSecondary, textTransform: 'uppercase', marginBottom: 4 }}>Questions</div>
                            <div style={{ fontSize: 14, fontWeight: 800, color: S.colors.textPrimary }}>{questions?.length} Total</div>
                        </div>
                        <div style={{ padding: 16, background: '#f0fdf4', borderRadius: 12, border: `1px solid ${S.colors.border}` }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: S.colors.primary, textTransform: 'uppercase', marginBottom: 4 }}>Auto Score</div>
                            <div style={{ fontSize: 14, fontWeight: 800, color: S.colors.primary }}>{submission?.total_score} Marks</div>
                        </div>
                    </div>

                    {/* Questions List */}
                    <h3 style={{ fontSize: 15, fontWeight: 800, color: S.colors.textPrimary, marginBottom: 16 }}>Questions & Your Answers</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                        {questions?.map((q, idx) => {
                            const studentAns = answers[idx];
                            return (
                                <div key={q.id} style={{ padding: 20, borderRadius: 16, border: `1.5px solid ${S.colors.border}`, background: '#fff' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                        <span style={{ fontWeight: 800, color: S.colors.primary, fontSize: 14 }}>Question {idx + 1}</span>
                                        <span style={{ fontSize: 12, fontWeight: 700, color: S.colors.textLight }}>{q.marks} Marks</span>
                                    </div>
                                    <p style={{ fontSize: 15, fontWeight: 500, color: S.colors.textPrimary, margin: '0 0 16px 0', lineHeight: 1.5 }}>{q.questionText}</p>
                                    
                                    {/* Answer Section */}
                                    <div style={{ padding: 16, borderRadius: 12, background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                        <div style={{ fontSize: 11, fontWeight: 700, color: S.colors.textSecondary, textTransform: 'uppercase', marginBottom: 8 }}>Your Answer:</div>
                                        
                                        {q.type === 'mcq' ? (
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                                {q.options.map((opt, oIdx) => {
                                                    const isSelected = studentAns?.selectedOption === oIdx;
                                                    return (
                                                        <div key={oIdx} style={{ 
                                                            display: 'flex', alignItems: 'center', gap: 10, fontSize: 14,
                                                            color: isSelected ? S.colors.primary : S.colors.textSecondary,
                                                            fontWeight: isSelected ? 700 : 400
                                                        }}>
                                                            <div style={{ 
                                                                width: 18, height: 18, borderRadius: '50%', 
                                                                border: `2px solid ${isSelected ? S.colors.primary : '#cbd5e1'}`,
                                                                display: 'flex', alignItems: 'center', justifyContent: 'center'
                                                            }}>
                                                                {isSelected && <div style={{ width: 8, height: 8, borderRadius: '50%', background: S.colors.primary }} />}
                                                            </div>
                                                            <span>{String.fromCharCode(65 + oIdx)}. {opt.text}</span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        ) : (
                                            <div style={{ fontSize: 14, color: S.colors.textPrimary, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                                                {studentAns?.answerText || <span style={{ color: S.colors.textLight, fontStyle: 'italic' }}>No text answer provided</span>}
                                            </div>
                                        )}

                                        {q.requiresUpload && studentAns?.uploadedFileUrl && (
                                            <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px dashed #cbd5e1' }}>
                                                <a href={apiBaseUrl + studentAns.uploadedFileUrl} target="_blank" rel="noreferrer" style={{ 
                                                    display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, color: S.colors.primary, 
                                                    textDecoration: 'none', fontWeight: 700 
                                                }}>
                                                    <FiFileText /> View Uploaded Attachment
                                                </a>
                                            </div>
                                        )}
                                    </div>

                                    {/* Grading Info */}
                                    {studentAns?.marks_awarded !== undefined && (
                                        <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <FiCheckCircle color={S.colors.success} size={16} />
                                            <span style={{ fontSize: 13, fontWeight: 700, color: S.colors.success }}>
                                                Score: {studentAns.marks_awarded} / {q.marks}
                                            </span>
                                            {studentAns.ai_feedback && (
                                                <span style={{ fontSize: 12, color: S.colors.textSecondary, marginLeft: 8 }}>
                                                    ({studentAns.ai_feedback})
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Modal Footer */}
                <div style={{ padding: '20px 24px', borderTop: `1px solid ${S.colors.border}`, textAlign: 'right' }}>
                    <button onClick={onClose} style={{ ...S.btnPrimary, padding: '10px 24px' }}>Close Review</button>
                </div>
            </div>
        </div>
    );
};

export default SubmissionReviewModal;
